<div class="grid grid-cols-1 md:grid-cols-4 p-4 gap-4">
  <aside class="col-span-1 overflow-hidden">
    <nav class="border-2 border-gray-200 rounded-md p-4 md:p-8 flex flex-row gap-2 flex-wrap sm:block sm:space-y-2 overflow-hidden">
      @for (link of links; track link) {
        <a
          href="#"
          class="hover:text-primary-600 mr-2 overflow-hidden block text-ellipsis"
          aria-current="page"
          [routerLink]="link.routerLink"
          [routerLinkActive]="'text-primary-600'"
          #rla="routerLinkActive"
        >
          <!-- <ng-icon
          [name]="link.icon"
          size="24px"
            [class]="
              rla.isActive
                ? 'text-primary-700 group-hover:text-primary-700 flex-shrink-0 -ml-1 mr-3 h-6 w-6'
                : 'text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6'
            "
        ></ng-icon> -->
          <span class="truncate">{{ link.name | i18n }}</span>
        </a>
      }
    </nav>
  </aside>

  <div class="col-span-1 sm:col-span-3 border-2 border-gray-200 rounded-md p-4 md:p-8">
    <router-outlet></router-outlet>
  </div>
</div>
